import { Card, CardContent, FormControlLabel, Grid, Switch, Typography, withStyles, WithStyles } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { buildComboSKUString, checkMinLength, checkStartAndEndDate, getCreateCourseDefaultFormData, getCreateCourseInitailStateForErrors } from "../../helpers/helpers";
import { courseStyles } from "../../styles";
import { CourseBasicDetails, CourseBasicDetailsErrors } from "../../types/interfaces/CourseBasicDetails";
import { bindActionCreators } from "redux";
import { BasicInfo } from "../../types/interfaces/BasicInfo";
import { getBasicInfo } from "../../actions/courseManagementActions";
import { courseManagementActions } from "../../reducers/courseManagementReducer";
import { withRouter } from "react-router";

import { dateService, MyPATSelect, MyPATTextField } from "../../../common";
import { onlyAllowNumbers } from "../../../../utils";
import SearchBarWithChips from "../../common/SearchBarWithChips";
import MyPATCalendar from "../../../common/MyPATCalendar";
import { DateCheck } from "../../types/enums/DateCheckResults";
import { ContentPreferences } from "../../types/enums/ContentPreferences";
import { User } from "../../types/interfaces/User";
import ACLService from "../../../acl/services/aclService";
import {
  getActiveGoals,
  getUserSuggestions,
  updateCourseBasicDetails
} from '../../actions/courseManagementActions';
import _ from "lodash";
import { Goal } from "../../types/interfaces/Goal";
import { CourseTypes } from "../../types/enums/CourseTypes";
import { contentManagementAction } from '../../reducers/contentMangementData';
import { parseJSON } from "date-fns";
import { createCoursePlanStatesAction } from '../../reducers/createCoursePlanReducer';
import courseManagementServices from "../../service/courseManagementServices";
import contentManagementService from "../../service/courseManagementServices";
import { durationMap } from "../CreateNewCourse/helper/getCourseDurationByDates";

interface Props extends WithStyles<typeof courseStyles> {
  basicInfo: BasicInfo;
  getBasicInfo: Function;
  finalResponse:any;
   match: any;
   goalList:any;
  userSuggestions: any;
  getActiveGoals: Function;
  getUserSuggestions: Function;
  activeGoals: any;
  goals: any;
  updateCourseBasicDetails: Function;
  setCourseBasicDetails: Function;
  treeData: any;
  setTreeData: Function;
  setPreferenceData: Function;
  getPackageByIdData: any;
  setBasicInfoMandatoryFlag: Function;
  setBasicInfo: Function;
  packageByIdData: any;
  coursePlanState:any;
  setCoursePlanStates:Function;
  showMenuIcon:boolean;
  location: any;
}

interface State {
  goalList:any;
  basicDetails: CourseBasicDetails;
  formErrors: CourseBasicDetailsErrors;
  editMode: boolean;
  activateUpdateCourseBtn: boolean;
  loggedInUserFullName: string;
  clientId: string;
  activeGoals: string[];
  courseId: string;
  courseTypes: string[];
  selectedCourseType: string;
  goals: any[];
  courses: any[];
  basicDetailsInitialState: CourseBasicDetails;
  values: { value: string, label: string, id: string, isRemovable?: boolean }[];
  defaultPackageAdmin: string;
  goalValues: {value: string, label: string, id: string, isRemovable?: boolean}[];
  goalSuggestion:{ value: string, label: string, id: string, isRemovable?: boolean }[];
  shareViewRights:boolean,
  isMyPatClient:boolean
}
class ComboCourseBasicInfo extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      basicDetails: getCreateCourseDefaultFormData(),
      formErrors: getCreateCourseInitailStateForErrors(),
      editMode: true,
      activateUpdateCourseBtn: false,
      loggedInUserFullName: '',
      clientId: '',
      defaultPackageAdmin: '',
      activeGoals: [],
      courseId: '',
      courseTypes: ['Standard Course', 'Goals'],
      selectedCourseType: this.props.match.params && this.props.match.params.type ? this.props.match.params.type : 'Standard Course',
      goals: [],
      courses: [],
      basicDetailsInitialState: getCreateCourseDefaultFormData(),
      values: [],
      goalList:[],
      goalValues:[],
      goalSuggestion:[],
      shareViewRights:false,
      isMyPatClient:false
    };
  }



  componentDidMount() {
    const {
      match: {
        params: { id = "" },
      },
    } = this.props;
    // this.props.getBasicInfo(id) //UNCOMMENT AFTER DEVELOPMENT, USING DUMMY ID BELOW
    // this.props.getBasicInfo("6038ab560e380aeb90f9dbe4");
    console.log(this.props.location.search.split('=')[this.props.location.search.split('=').length - 1]);
    const selectedType = this.props.location.search.split('=')[this.props.location.search.split('=').length - 1] || 
                          this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1];
    console.log(selectedType);
    

    setTimeout(() => {
      const basicInfo = this.setBasicInfo(this.refineBasicInfo(this.props.basicInfo));
      this.props.setBasicInfo(basicInfo);
    }, 5000)

    const recievedData = { ...this.state.basicDetails };

    const userData = ACLService.getUserDetailsFromStorage();
    const clientId = userData.authenticatedUser.aclMetaData.clientId;
    const fullName = userData.authenticatedUser.fullName;
    const clientID = userData.authenticatedUser.id;
    this.props.getActiveGoals();
    this.props.getUserSuggestions({
      clientId: clientId,
    });
   
    courseManagementServices.getPackageById(id).then((response: any) => {
      const { packageData } = response.responseObject
      // if (packageData.coursePlanId && packageData.status !== 'DRAFT') {
      const goalLevel = _.get(packageData.courseDetails, '[0].courseType.id');
      contentManagementService.getGoalLevel(goalLevel).then((res: any) => {
      let valuelist: any = [];
      res.goalLevels.forEach((ele: any) => {
      let element = { id: ele._id, label: ele.name, value: ele.name,isRemovable:true };
      valuelist.push(element);
      });
      let goalValueList:any  =[];
      this.props.finalResponse && this.props.finalResponse.goalLevels && this.props.finalResponse.goalLevels.forEach((ele:any)=>{
          let element = { id: ele._id, label: ele.name,value:ele.name,isRemovable:true };
          goalValueList.push(element);
        }); 
      this.setState({
      goalList: valuelist,
      goalSuggestion:valuelist,
      goalValues:goalValueList,
      shareViewRights:packageData.isSharedWithFiitjeeClients
      });
      });
      //}
      })
     this.setState({
      loggedInUserFullName: fullName,
      clientId: clientId,
      courseId: id,
      basicDetailsInitialState: recievedData,
      selectedCourseType: selectedType, 
      isMyPatClient:clientId=="5b5702e095cbc921944632a9"
     // goalValues:valueList
    })
    
    if (this.props.packageByIdData.packageData) {
      this.setInitialPackageAdminValues();
    }
   

  }




  refineBasicInfo = (basicInfo: any) => {
    const updatedBasicInfo = JSON.parse(JSON.stringify(basicInfo));
    if (Object.keys(basicInfo).length) {
      delete updatedBasicInfo.sku;
      updatedBasicInfo.sku = {};
      updatedBasicInfo.sku.SKUText = (basicInfo.sku && typeof basicInfo.sku === 'string') ? basicInfo.sku.split("-")[0] : basicInfo.sku.SKUText;
      updatedBasicInfo.sku.SKUNumber = (basicInfo.sku && typeof basicInfo.sku === 'string') ? basicInfo.sku.split("-")[1] : basicInfo.sku.SKUNumber;
      try {
        let SKUYear;
        if (!!basicInfo.sku && !!basicInfo.sku.SKUYear) {
          updatedBasicInfo.sku.SKUYear = basicInfo.sku.SKUYear;
        } else if(!!basicInfo.sku && typeof basicInfo.sku === 'string') {
          let yearParts = (basicInfo.sku).split("-");
          SKUYear = yearParts[yearParts.length - 1];
          updatedBasicInfo.sku.SKUYear = SKUYear;
        }
      } catch (e) {
      }
      return updatedBasicInfo;
    }
    return updatedBasicInfo;
  };

  prepareReceivedData = (data: { firstName: string, lastName: string, id: string, isRemovable: boolean }[]) => {
    const preparedData = data.map(admin => ({
      value: `${admin.firstName} ${admin.lastName}`,
      label: `${admin.firstName} ${admin.lastName}`,
      id: admin.id,
      isRemovable: admin.isRemovable
    }))
    return preparedData;
  }
  setShareEditKey=()=>{
    const updatedFormData={...this.state.basicDetails};
    updatedFormData.isSharedWithFiitjeeClients=!this.state.shareViewRights;
    this.setState(
      {
        basicDetails: updatedFormData,
        shareViewRights:!this.state.shareViewRights
      },
      () => {
        this.props.setCourseBasicDetails(this.state.basicDetails)
        this.props.setBasicInfo(this.state.basicDetails);
      }
    );
   }
  setInitialPackageAdminValues = () => {
    const { firstName, lastName, id: adminId, isRemovable } = this.props.packageByIdData.packageData && this.props.packageByIdData.packageData.packageAdmins[0];
    const preparedData = this.props.packageByIdData.packageData && this.prepareReceivedData(this.props.packageByIdData.packageData.packageAdmins)

    const { values } = this.state
    let updatedValues = [
      ...preparedData,
    ]

    let filteredValues: any = [];
    updatedValues.map(value => {
      let itemExists = false
      filteredValues.forEach((val: any) => {
        if (val.id === value.id) itemExists = true;
      })
      if (!itemExists) {
        filteredValues.push(value)
      }
    })

    this.setState({
      values: filteredValues,
      defaultPackageAdmin: `${firstName} ${lastName}`
    })
  }
  componentDidUpdate(prevProps: Props,prevState:State) {
    // if (prevProps.basicInfo !== this.props.basicInfo) {
    if (!_.isEqual(prevProps.basicInfo, this.props.basicInfo)) {
      // Set data in state basic details object
      
      

      
      

      this.setBasicInfo(this.refineBasicInfo(this.props.basicInfo));

  
    }

    if (prevProps.goals !== this.props.goals) {
      this.setActiveGoals(this.props.goals);
    }

    if (prevProps.packageByIdData !== this.props.packageByIdData) {
      this.setInitialPackageAdminValues();
      this.setCourseDuration()
    }
    if(prevState.shareViewRights!==this.state.shareViewRights){
      this.setBasicInfo(this.refineBasicInfo(this.props.basicInfo));
    }
  }

  setCourseDuration = () => {
    const  packageData  = _.get(this.props, "packageByIdData.packageData", 0);
    const { duration } = packageData;
    console.log('::::; Duration ::::::::', duration); 
    const { basicDetails } = this.state;
    let updatedBasicDetails = {...basicDetails};
    updatedBasicDetails.duration = duration;
    
    this.setState({
      basicDetails: updatedBasicDetails
    })
  }
  // renderSelectCourseTypeOptions = () => {
  //   let options: any = [];
  //   // options.push(<option value={''}>{'Select Course Type'}</option>);
  //   _.map(this.state.courseTypes, (course: string, index: number) =>
  //     options.push(
  //       <option key={index} value={course}>
  //         {course}
  //       </option>
  //     )
  //   );
  //   return options;
  // };

  setActiveGoals = (goalData: Goal[]) => {
    const goalNameArray = goalData.map((goal) => goal.name);
    this.setState({
      activeGoals: goalNameArray,
    });
  };

  validateDate = (basicInfoDate: any, type: string) => {
    if (typeof basicInfoDate === 'string') {
      return basicInfoDate
    } else {
      return basicInfoDate[type]
    }
  }

  checkMandatoryFields = (basicDetails: any) => {
    let mandatoryFieldsFilled = true;

    if (
      basicDetails.name === '' ||
      basicDetails.sku.SKUText === '' ||
      basicDetails.sku.SKUNumber === '' ||
      basicDetails.courseDetails === '' ||
      basicDetails.startDate.value === '' ||
      basicDetails.startDate.label === '' ||
      basicDetails.endDate.value === '' ||
      basicDetails.endDate.label === ''
    ) {
      mandatoryFieldsFilled = false;
    }

    return mandatoryFieldsFilled;
  }
  setBasicInfo = (data: any) => {
    // //console.log('::;DATA::::', data);
    if (Object.keys(data).length) {
      const { basicDetails } = this.state;
      const updatedBasicDetails = JSON.parse(JSON.stringify(basicDetails));
      updatedBasicDetails.name = data.name;

      updatedBasicDetails.sku.SKUText = data.sku.SKUText;
      updatedBasicDetails.sku.SKUNumber = data.sku.SKUNumber;
      try {
        let SKUYear;
        if (!!data.sku && !!data.sku.SKUYear) {
          updatedBasicDetails.sku.SKUYear = data.sku.SKUYear;
        } else if(!!data.sku && typeof data.sku === 'string') {
          let yearParts = (data.sku).split("-");
          SKUYear = yearParts[yearParts.length - 1];
          updatedBasicDetails.sku.SKUYear = SKUYear;
        }
      } catch (e) {
      }
      updatedBasicDetails.type = data.type;
      updatedBasicDetails.courseDetails = data.courseDetails || [];
      updatedBasicDetails.startDate.value = data.startDate && this.validateDate(data.startDate, 'value');
      updatedBasicDetails.startDate.label = data.startDate && dateService.dateOnly(this.validateDate(data.startDate, 'label'));
      updatedBasicDetails.endDate.value = (data.endDate || data.expiryDate) && this.validateDate(data.expiryDate ? data.expiryDate : data.endDate, 'value');
      updatedBasicDetails.endDate.label = (data.endDate || data.expiryDate) && dateService.dateOnly(this.validateDate(data.expiryDate, 'label'));
      updatedBasicDetails.contentPreferences.chapterTests.enabled =
        _.get(data.contentPreferences, 'chapterTests.enabled', false);
      updatedBasicDetails.contentPreferences.conceptTests.enabled =
        _.get(data.contentPreferences, 'conceptTests.enabled', false);
      updatedBasicDetails.contentPreferences.scheduledTests.enabled =
        _.get(data.contentPreferences, 'scheduledTests.enabled', false);
      updatedBasicDetails.contentPreferences.studyNotes.enabled =
        _.get(data.contentPreferences, 'studyNotes.enabled', false);
      updatedBasicDetails.contentPreferences.video.enabled =
        _.get(data.contentPreferences, 'video.enabled', false);
      updatedBasicDetails.packageAdmins = data.packageAdmins && [
        ...data.packageAdmins,
      ];
      updatedBasicDetails.includedPackages = data.includedPackages && [...data.includedPackages]
      updatedBasicDetails.isSharedWithFiitjeeClients=this.state.shareViewRights;
      const basicInfoMandatoryFieldsFilled = this.checkMandatoryFields(updatedBasicDetails);
      // //console.log(basicInfoMandatoryFieldsFilled)


      this.props.setBasicInfoMandatoryFlag(basicInfoMandatoryFieldsFilled)

      this.setState((prevState) => {
        return {
          ...prevState,
          basicDetails: updatedBasicDetails,
        }
      },
        () => {
          this.props.setCourseBasicDetails(this.state.basicDetails)
          //  this.props.setBasicInfo(this.state.basicDetails)
        }
      );
      return updatedBasicDetails;
    }
  };


  handleChange = (event: any) => {
    const { name, value } = event.target;
    const updatedFormData = { ...this.state.basicDetails };
    const updatedFormErrors = { ...this.state.formErrors };
    ////console.log('Name ->', name);
    ////console.log('Value ->', value);
    switch (name) {
      case 'name':
        updatedFormData.name = value;
        if (updatedFormErrors.name === 'untouched') {
          updatedFormErrors.name = '';
        }
        this.validateFormData('name');
        break;
      case 'skuText':
        let updatedSKU = { ...updatedFormData.sku }
        updatedSKU.SKUText = value;
        updatedFormData.sku = updatedSKU;
        if (updatedFormErrors.sku.SKUText === 'untouched') {
          updatedFormErrors.sku.SKUText = '';
        }
        this.validateFormData('sku.SKUText');
        break;
      case 'skuNumber':
        let updatedSku = { ...updatedFormData.sku }
        updatedSku.SKUNumber = value.replace(/[^\w\s]/gi, '');
        updatedFormData.sku = updatedSku;

        if (updatedFormErrors.sku.SKUNumber === 'untouched') {
          updatedFormErrors.sku.SKUNumber = '';
        }
        this.validateFormData('sku.SKUNumber');
        break;
      case 'goal':
        updatedFormData.courseDetails = value;
        const SKUYear = value.split('-');
        updatedFormData.sku.SKUYear = SKUYear[SKUYear.length - 1];
        if (updatedFormErrors.courseDetails === 'untouched') {
          updatedFormErrors.courseDetails = '';
        }
        this.validateFormData('goal');
        break;
      case 'courseDuration':
        updatedFormData.duration = +value;
        
        break;
      default:
    }
    this.setState(
      {
        basicDetails: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        this.canActivateUpdateCourseBtn();
        this.props.setCourseBasicDetails(this.state.basicDetails)
        this.props.setBasicInfo(this.state.basicDetails)
      }
    );
  };

  handleDateSelection = (date: any, type: string) => {
    // console.log(date);
    const { treeData, setTreeData, coursePlanState,setCoursePlanStates } = this.props;
    const coursePlanDataLen =  Object.keys(coursePlanState).length
  //  const { startDate = '', endDate = '', weekFormat = '' } = coursePlanState;
    const updatedFormData = { ...this.state.basicDetails };
    const updatedFormErrors = { ...this.state.formErrors };
    const formattedDate = dateService.dateOnly(date);
    const treeDataLen = Object.keys(treeData).length;
    let cloneTree = { startDate: "", endDate: "" };
    if (treeDataLen) {
      cloneTree = JSON.parse(JSON.stringify(treeData));
    }
    let coursePlanDataClone = { startDate: "", endDate: "" };
    if(coursePlanDataLen){
      coursePlanDataClone = JSON.parse(JSON.stringify(coursePlanState));
    }

    switch (type) {
      case 'startDate':
        let updatedStartDate = { ...updatedFormData.startDate }
        updatedStartDate.label = formattedDate;
        updatedStartDate.value = date;
        updatedFormData.startDate = updatedStartDate;
        updatedFormErrors.startDate = '';
        this.validateFormData('date');
        if (coursePlanDataLen) {
          coursePlanDataClone.startDate = date;
        }
        if (treeDataLen > 0) {
          cloneTree.startDate = date;
        }
        break;
      case 'endDate':
        let updatedEndDate = { ...updatedFormData.endDate }
        updatedEndDate.label = formattedDate;
        updatedEndDate.value = date;
        updatedFormData.endDate = updatedEndDate;
        updatedFormErrors.endDate = '';
        this.validateFormData('date');
        if (coursePlanDataLen) {
          coursePlanDataClone.endDate = date;
        }
        if (treeDataLen > 0) {
          cloneTree.endDate = date;
        }
        break;
      default:
    }
    this.setState(
      {
        basicDetails: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {

        if (treeDataLen > 0) {
          setTreeData({ treeData: cloneTree });
        }

        if (coursePlanDataLen) {
          //coursePlanDataClone.endDate = date;
          setCoursePlanStates({ coursePlanState: coursePlanDataClone });
        }
        
        this.props.setCourseBasicDetails(this.state.basicDetails)
        this.canActivateUpdateCourseBtn();
        this.props.setBasicInfo(this.state.basicDetails);
      }
    );
  };

  handleToggle = (contentType: string) => {
    const updatedFormData = { ...this.state.basicDetails };
    const updatedFormErrors = { ...this.state.formErrors };
    let updatedContentPreferences = { ...updatedFormData.contentPreferences };
    //let copyPackageByIdData = {...this.props.getPackageByIdData};
    let copyContentPreferences = JSON.parse(JSON.stringify(this.props.packageByIdData.packageData && this.props.packageByIdData.packageData.contentPreferences));

    switch (contentType) {
      case ContentPreferences.conceptTests:
        let updatedConceptTests = { ...updatedFormData.contentPreferences.conceptTests }
        updatedConceptTests.enabled = !updatedFormData.contentPreferences.conceptTests.enabled;
        updatedContentPreferences.conceptTests = updatedConceptTests;
        copyContentPreferences.conceptTests.enabled = !updatedFormData.contentPreferences.conceptTests.enabled;
        break;
      case ContentPreferences.video:
        let updatedVideo = { ...updatedFormData.contentPreferences.video }
        updatedVideo.enabled = !updatedFormData.contentPreferences.video.enabled;
        updatedContentPreferences.video = updatedVideo;
        copyContentPreferences.video.enabled = !updatedFormData.contentPreferences.video.enabled;
        break;
      case ContentPreferences.chapterTests:
        let updatedChapterTests = { ...updatedFormData.contentPreferences.chapterTests }
        updatedChapterTests.enabled = !updatedFormData.contentPreferences.chapterTests.enabled;
        updatedContentPreferences.chapterTests = updatedChapterTests;
        copyContentPreferences.chapterTests.enabled = !updatedFormData.contentPreferences.chapterTests.enabled;
        break;
      case ContentPreferences.studyNotes:
        let updatedStudyNotes = { ...updatedFormData.contentPreferences.studyNotes }
        updatedStudyNotes.enabled = !updatedFormData.contentPreferences.studyNotes.enabled;
        updatedContentPreferences.studyNotes = updatedStudyNotes;
        copyContentPreferences.studyNotes.enabled = !updatedFormData.contentPreferences.studyNotes.enabled;
        break;
      case ContentPreferences.scheduledTests:
        let updatedScheduledTests = { ...updatedFormData.contentPreferences.scheduledTests }
        updatedScheduledTests.enabled = !updatedFormData.contentPreferences.scheduledTests.enabled;
        updatedContentPreferences.scheduledTests = updatedScheduledTests;
        copyContentPreferences.scheduledTests.enabled = !updatedFormData.contentPreferences.scheduledTests.enabled;
        break;
      default:
    }
    updatedFormData.contentPreferences = { ...updatedContentPreferences };


    if (
      updatedFormData.contentPreferences.conceptTests.enabled ||
      updatedFormData.contentPreferences.video.enabled ||
      updatedFormData.contentPreferences.chapterTests.enabled ||
      updatedFormData.contentPreferences.studyNotes.enabled ||
      updatedFormData.contentPreferences.scheduledTests.enabled
    ) {
      updatedFormErrors.contentPreferences = '';
    } else {
      updatedFormErrors.contentPreferences =
        'Select atleast one content preference.';
    }

    this.setState(
      {
        basicDetails: updatedFormData,
        formErrors: updatedFormErrors,
      },
      () => {
        this.props.setCourseBasicDetails(this.state.basicDetails)
        this.props.setBasicInfo(this.state.basicDetails);
        this.canActivateUpdateCourseBtn();
        this.props.setPreferenceData(copyContentPreferences);
      }
    );
  };

  handleCourseAdminNames = (
    names: { value: string; label: string; id: string }[]
  ) => {
    // //console.log('------------>',names);
    this.validateFormData('courseAdmins', names);
    let updatedFormErrors = this.state.formErrors;
    const { defaultPackageAdmin } = this.state;
    if (names !== null) {
      const admins = names.filter((name) => name.id);
      // //console.log(admins);
      let selectedAdmins: any = [];
      admins.forEach((admin) => {
        const currentUser = this.props.userSuggestions.filter(
          (user: any) => user._id === admin.id
        );
        selectedAdmins.push(currentUser[0]);
      });
      //  //console.log(selectedAdmins)
      const trimmedAdminObjects = selectedAdmins.map((admin: User) => ({
        id: admin._id,
        firstName: admin.firstName,
        lastName: admin.lastName,
        isRemovable: defaultPackageAdmin.toString().includes(`${admin.firstName}`) ? false : true,
      }));
      // //console.log(trimmedAdminObjects);

      let updatedValues = trimmedAdminObjects.map((admin: any) => ({
        label: `${admin.firstName} ${admin.lastName}`,
        value: `${admin.firstName} ${admin.lastName}`,
        id: admin.id,
        isRemovable: defaultPackageAdmin.toString().includes(`${admin.firstName}`) ? false : true
      }))
      // const userObject = this.props.userSuggestions.filter((user) => user.firstName === firstName )


      let { basicDetails } = this.state;
      let { packageAdmins } = basicDetails;
      // packageAdmins = trimmedAdminObjects;
      let updatedBasicDetails = { ...basicDetails }
      updatedBasicDetails.packageAdmins = trimmedAdminObjects;

      updatedFormErrors.packageAdmins = '';

      this.canActivateUpdateCourseBtn();
      this.setState(
        {
          basicDetails: updatedBasicDetails,
          formErrors: updatedFormErrors,
          values: updatedValues
        },
        () => {
          // //console.log(this.state.formData);
          this.props.setCourseBasicDetails(this.state.basicDetails)
          this.props.setBasicInfo(this.state.basicDetails)
          this.canActivateUpdateCourseBtn();
        }
      );
    } else {
      let { basicDetails } = this.state;
      let { packageAdmins } = basicDetails;
      packageAdmins = [];
      basicDetails.packageAdmins = packageAdmins;
      this.setState({
        basicDetails: basicDetails
      }, () => {
        this.props.setCourseBasicDetails(this.state.basicDetails);
        this.props.setBasicInfo(this.state.basicDetails);
        this.canActivateUpdateCourseBtn()
      })
    }
  };

  handleOnboardingStartDateChnage = (data: any) => {
    const { basicDetails } = this.state;
    const updatedForm = { ...basicDetails }
    const onboardingDates = { ...updatedForm.onboardingIntervals }
    onboardingDates.startDate = data;
    // //console.log(updatedForm)
    // this.setState({
    //   basicDetails:updatedForm
    // },()=>{
    //   this.props.setCourseBasicDetails(updatedForm)
    // })

  }

  handleOnboardingEndDateChnage = (data: any) => {
    const updatedForm = { ...this.state.basicDetails }
    const onboardingDates = { ...updatedForm.onboardingIntervals }
    onboardingDates.endDate = data;
    // this.setState({
    //   basicDetails:updatedForm
    // },()=>{
    //   this.props.setCourseBasicDetails(updatedForm)
    // })

  }
  handleGoalLevel = (selectedGoalValue: any[]) => {
    //console.log(evn);
   const { goalList } = this.state;
    const { basicInfo } = this.props
   // const goalList = basicInfo.goalLevels
    let newGoalList:any = [];
    let goalIdMap: any = {}
    if (selectedGoalValue !== null) {
    selectedGoalValue.forEach((selectedData: any) => {
    goalIdMap[`${selectedData.id}`] = selectedData
    })
    goalList.forEach((data: any) => {
    const { id } = data;
    const isPresent = false;
    if (!goalIdMap.hasOwnProperty(id)) {
    newGoalList.push(data)
    }
    })
    }else{
    selectedGoalValue =[];
    newGoalList= this.state.goalList;
    }
    this.setState({
    goalValues:selectedGoalValue,
    goalSuggestion:newGoalList
    })
    }
    handleDescriptionChange=(event:any)=>{
      const updatedbasicDetails = { ...this.state.basicDetails };
      updatedbasicDetails.description = event.target.value;
      this.setState({
        basicDetails:updatedbasicDetails
      },
      ()=>{
        this.props.setCourseBasicDetails(this.state.basicDetails)
        // this.props.setBasicInfo(this.state.basicDetails)
      })
      }
  canActivateUpdateCourseBtn = () => {
    const { formErrors } = this.state;
    // //console.log(formErrors);
    let activateUpdateCourseBtn = false;

    if (
      formErrors.name === '' &&
      formErrors.sku.SKUText === '' &&
      formErrors.sku.SKUNumber === '' &&
      formErrors.courseDetails === '' &&
      formErrors.startDate === '' &&
      formErrors.endDate === '' &&
      formErrors.contentPreferences === '' &&
      formErrors.packageAdmins === ''
    ) {
  
      activateUpdateCourseBtn = true;
    } else {
      activateUpdateCourseBtn = false;
    }

    this.setState(
      {
        activateUpdateCourseBtn: activateUpdateCourseBtn,
      }
    );
  };

  validateFormData = (field: string, data?: any) => {
    const { basicDetails, formErrors } = this.state;
    const {
      name,
      sku: { SKUText, SKUNumber, SKUYear },
      courseDetails,
      startDate,
      endDate,
      packageAdmins,
    } = basicDetails;

    switch (field) {
      case 'name':
        formErrors.name = checkMinLength(name, 5)
          ? ''
          : 'Enter atleast 5 characters';
        break;
      case 'sku.SKUText':
        formErrors.sku.SKUText = checkMinLength(SKUText, 3)
          ? ''
          : 'Enter atleast 3 characters';
        break;
      case 'sku.SKUNumber':
        formErrors.sku.SKUNumber = checkMinLength(SKUNumber.toString(), 1)
          ? ''
          : 'Enter atleast 1 character';
        break;
      case 'date':
        const dateCheckResult = checkStartAndEndDate(startDate.value, endDate.value);
        switch (dateCheckResult) {
          case DateCheck.startGreaterThanEnd:
            formErrors.startDate = DateCheck.startGreaterThanEnd;
            break;
          case DateCheck.endLessThanStart:
            formErrors.endDate = DateCheck.endLessThanStart;
            break;
          default:
            formErrors.startDate = '';
            formErrors.endDate = ''
        }
        break;
      case 'goal':
        formErrors.courseDetails = courseDetails.length > 0
          ? ''
          : 'Select a goal';
        break;
      case 'courseAdmins':
        formErrors.packageAdmins = data !== null
          ? ''
          : 'Select atleast one course admin';
        break;
      default:
    }

    this.setState({
      formErrors: formErrors,
    });
  };

  getSKUYear = (data: any) => {
    const length = data.length;
    let skuYear = data[0];
    for (let i = 1; i < length; i++) {
      if (skuYear > data[i]) {
        skuYear = data[i];
      }
    }
    return skuYear;
  }

  handleSubmit = () => {
    const { basicDetails, courseId } = this.state;
    basicDetails.type = CourseTypes.combo;
    basicDetails.targetYears = [basicDetails.sku.SKUYear];
    // const goalData = this.prepareCourseDetailArray();\
    const year = this.getSKUYear([basicDetails.sku.SKUYear]);
    basicDetails.courseDetails = this.state.basicDetails.courseDetails;
    basicDetails.sku = buildComboSKUString(this.state.basicDetails.sku, year);
    basicDetails.startDate = basicDetails.startDate.value;
    basicDetails.expiryDate = basicDetails.endDate.value;

    this.props.updateCourseBasicDetails({
      courseBasicDetails: basicDetails,
      packageId: courseId
    });


  };

  getCourseDurationOptions = () => {
    let options = [];
    options.push(<option value={0}>{'Select Course Duration'}</option>);
    _.map(durationMap, (duration: {label: string, value: number}, index: number) =>
          options.push(
            <option key={index} value={duration.value}>
                {duration.label}
            </option>
        )
    );
    return options;
  }

  render() {
    const { classes,showMenuIcon,basicInfo } = this.props;
    const { editMode, basicDetails } = this.state;

    const { phases } = this.props.treeData;
    const startDate = this.state.basicDetails.startDate.value
      ? new Date(this.state.basicDetails.startDate.value)
      : this.state.basicDetails.startDate.value;

    const endDate = this.state.basicDetails.endDate.value
      ? new Date(this.state.basicDetails.endDate.value)
      : this.state.basicDetails.endDate.value;

    const phaseStartDate = (phases && phases[0]) ? new Date(phases[0].startDate) : startDate;
    const phaseEndDate = (phases && phases[phases.length - 1]) ? new Date(phases[phases.length - 1].endDate) : endDate;


    let includedPackages = (this.state.basicDetails.includedPackages !== undefined && this.state.basicDetails.includedPackages.length > 0) ? this.state.basicDetails.includedPackages.find((pkg: any) => pkg.primary === true).name : '';
    let courseDetails = (this.state.basicDetails.courseDetails !== undefined && this.state.basicDetails.courseDetails.length > 0) ? this.state.basicDetails.courseDetails.find((pkg: any) => pkg.primary === true).courseName : '';

    let AllIncludedPackages: any = [];
    this.state.basicDetails.includedPackages !== undefined && this.state.basicDetails.includedPackages.length > 0 && this.state.basicDetails.includedPackages.forEach((pkg: any) => {
      AllIncludedPackages.push(pkg.name);
    });

    let AllCourseDetails: any = [];

    this.state.basicDetails.courseDetails !== undefined && this.state.basicDetails.courseDetails.length > 0 && this.state.basicDetails.courseDetails.find((pkg: any) => {
      AllCourseDetails.push(pkg.courseName);
    });
    const phase: any = basicDetails.phaseAlignment;
    const onboardingInterval = { ...basicDetails.onboardingIntervals }

    let date = new Date(_.get(basicInfo.phaseAlignment,"startDate"))
    const month =["January","february","March","April","May","June","July","August","September","October","November","December"]
    let phasesStartDate = date.getDate()+" " + month[date.getMonth()] +" "+date.getFullYear()
    const phaseAlignment = _.get(basicInfo.phaseAlignment,"name") + " Onwards " + phasesStartDate;
    const onboardingIntervalStartDate = _.get(basicInfo.onboardingInterval,"startDate")
    const onboardingIntervalEndDate = _.get(basicInfo.onboardingInterval,"endDate");
    const status=_.get(basicInfo,'status','DRAFT');
   return (
      <div>
        <Card elevation={0} classes={{ root: classes.cardContainer }}>
          {/* <DialogHeader
                    urlName="/course-Management"
                    // selectedTab="Clients"
                    iconNode={
                    <IconButton
                        aria-label="settings"
                        // onClick={dialogCloseHandler}
                    >
                        <CloseIcon
                        // className={classes.fontSizeLG}
                        />
                    </IconButton>
                    }
                    headerTitle="Create New Course"
                /> */}

          <CardContent className={classes.cardContentStyle}>
            <Grid container>
              <Grid item xs={8}>
                <Typography className={classes.cardHeading}>
                  Course Basic Details<span>*</span>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={8}>
              <Grid item xs={8}>
                <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>
                      Course Name
                        </Typography>
                    <MyPATTextField
                      //   className={classes.inputWidth}
                      fullWidthControl
                      inputId="name"
                      name="name"
                      placeholder="Course Name"
                      // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                      value={this.state.basicDetails.name || ''}
                      onChange={this.handleChange.bind(this)}
                      error={
                        this.state.formErrors.name !== '' &&
                          this.state.formErrors.name !== 'untouched'
                          ? true
                          : false
                      }
                      errorText={this.state.formErrors.name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>
                      SKU
                        </Typography>
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                        <MyPATTextField
                          //   className={classes.inputWidth}
                          fullWidthControl
                          inputId="skuText"
                          name="skuText"
                          placeholder="E.g. JEE"
                          disabled={status.toUpperCase()!='DRAFT'}
                          value={this.state.basicDetails.sku.SKUText || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.sku.SKUText !== '' &&
                              this.state.formErrors.sku.SKUText !== 'untouched'
                              ? true
                              : false
                          }
                          errorText={this.state.formErrors.sku.SKUText}
                        />
                        <span className={classes.smallInfo}>
                          Atleast 3 characters{" "}
                        </span>
                      </Grid>

                      <Grid item xs={6}>
                        <MyPATTextField
                          //   className={classes.inputWidth}
                          fullWidthControl
                          inputId="skuNumber"
                          name="skuNumber"
                          placeholder="01"
                          disabled={status.toUpperCase()!='DRAFT'}
                          value={this.state.basicDetails.sku.SKUNumber || ''}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.sku.SKUNumber !== '' &&
                              this.state.formErrors.sku.SKUNumber !== 'untouched'
                              ? true
                              : false
                          }
                          errorText={this.state.formErrors.sku.SKUNumber}
                          onKeyPress={onlyAllowNumbers}
                        />
                        <span className={classes.smallInfo}>
                          Value must be numeric{" "}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container spacing={8} className={classes.mt30}>
                  <Grid item xs={6} className={classes.fullWidthSelect}>
                    <Typography className={classes.inputLable}>Combo Course to be created from</Typography>
                    {/* <MyPATSelect
                      value={this.state.selectedCourseType}
                      name='CourseCreated'
                      onChange={(e: any) => this.handleChange(e)}
                    >
                      {this.renderSelectCourseTypeOptions()}
                    </MyPATSelect> */}
                    <MyPATTextField
                      fullWidthControl
                      //inputId=""
                      name="CourseCreated"
                      placeholder="01"
                      value={this.state.selectedCourseType}
                      disabled={true}
                    />

                  </Grid>
                  {this.state.selectedCourseType === 'Goals' ? (
                    <Grid item xs={6}>
                      <>
                        <Typography className={classes.inputLable}>Select Goal</Typography>
                        <Grid item xs={12}>
                          {/* <SearchBarWithChips
                            courses={[]}
                            suggestions={[]}
                            placeholderText='Select Goals'
                            //this.state.basicDetails.goalsDetails
                            //onSelection={this.handleGoalsNames}
                            classes={{ root: classes.searchBarChips }}
                          /> */}

                          <MyPATTextField
                            fullWidthControl
                            //inputId=""
                            name="selectedGoals"
                            placeholder="01"
                            value={AllCourseDetails.join(', ')}
                            disabled={true}
                          />
                        </Grid>
                      </>
                    </Grid>
                  ) : (
                      <Grid item xs={6}>
                        <>
                          <Typography className={classes.inputLable}>Select Course(s)</Typography>
                          <Grid item xs={12}>
                            <MyPATTextField
                              fullWidthControl
                              //inputId=""
                              name="selectedCourse"
                              placeholder="01"
                              value={AllIncludedPackages.join(', ')}
                              disabled={true}
                            />
                            {/* <SearchBarWithChips
                              suggestions={[]}
                              courses={[]}
                              placeholderText='Select Course'
                              //onSelection={this.handleCourseNames}
                              classes={{ root: classes.searchBarChips }}
                            /> */}
                          </Grid>
                        </>
                      </Grid>
                    )}
                </Grid>

                <Grid container spacing={8} className={classes.mt30}>
                  {/* Start: Use this code format for UI design as per figma for standard course*/}
                  {this.state.selectedCourseType === 'Goals' ? (
                    <Grid item xs={6}>
                      <Typography className={classes.inputLable}>Select Primary Goal</Typography>

                      <MyPATTextField

                        fullWidthControl
                        inputId=""
                        name=""
                        placeholder="01"
                        value={courseDetails}
                        disabled={true}
                      />
                    </Grid>
                  ) : (
                      <Grid item xs={6}>
                        <Grid item xs={12} className={classes.fullWidthSelect}>
                          <Typography className={classes.inputLable}>Select Primary Course Plan</Typography>


                          <MyPATTextField
                            //   className={classes.inputWidth}
                            fullWidthControl
                            inputId=""
                            name=""
                            placeholder="01"
                            // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                            value={includedPackages}
                            disabled={true}
                          />

                        </Grid>
                      </Grid>
                    )}

                  <Grid item xs={6}>
                    <Grid container spacing={16}>
                      <Grid item xs={6} className={classes.customCalendar}>
                        <Typography className={classes.inputLable}>Start Date </Typography>
                        <MyPATCalendar
                          fullWidthControl
                          onChange={(dateVal: string) =>
                            this.handleDateSelection(dateVal, 'startDate')
                          }
                          date={this.state.basicDetails.startDate.value}
                          placeholder="Select Start Date"
                          // minDate={this.state.basicDetails.startDate.value}
                          maxDate={phaseStartDate}
                          disabled={this.props.match.params.type === 'Standard Course' ? true : false}
                        />
                      </Grid>
                      <Grid item xs={6} className={classes.customCalendar}>
                        <Typography className={classes.inputLable}>End Date</Typography>
                        <MyPATCalendar
                          fullWidthControl
                          onChange={(dateVal: string) =>
                            this.handleDateSelection(dateVal, 'endDate')
                          }
                          date={this.state.basicDetails.endDate.value}
                          // disabled={true}
                          placeholder="Select End Date"
                          // minDate={startDate}
                          minDate={phaseEndDate}
                          disabled={this.props.match.params.type === 'Standard Course' ? true : false}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* End: Use this code format for UI design as per figma */}

                </Grid>
                {
                          showMenuIcon &&
                          <>
                            <Grid container spacing={16}>
                              <Grid item xs={6}>
                                <Typography className={classes.inputLable}>
                                  Onboarding Interval<span className={classes.redColor}>*</span>
                                </Typography>
                                  <Grid container spacing={16}>                            
                                    <Grid item xs={6} className={classes.customCalendar} style={{display: 'flex', alignItems: 'center'}}>
                                      <MyPATCalendar
                                        fullWidthControl
                                        date={onboardingIntervalStartDate}
                                        minDate={new Date()}
                                        maxDate={onboardingIntervalEndDate}
                                        placeholder='onBoardingStartDate'
                                        onChange={this.handleOnboardingStartDateChnage}
                                      />
                                      <span style={{ marginLeft:10, marginRight:'-5px', marginBottom:10, fontSize:18, transform: "scaleX(2)"}}>-</span>
                                    </Grid>
                                    <Grid item xs={6} className={classes.customCalendar}>
                                      <MyPATCalendar
                                        fullWidthControl
                                        date={onboardingIntervalEndDate}
                                        minDate={onboardingIntervalStartDate}
                                        maxDate={basicInfo ? basicInfo.expiryDate : ""}
                                        placeholder='onBoardingEndDate'
                                        name='onBoardingEndDate'
                                        onChange={this.handleOnboardingEndDateChnage}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography className={classes.inputLable}>Select Rank Range (optional)</Typography>
                                  <SearchBarWithChips
                                    suggestions={this.state.goalSuggestion}
                                    placeholderText='Select Goal Level'
                                    onSelection={this.handleGoalLevel}
                                    //loggedInUserFullName={this.state.goalValues}
                                    values={this.state.goalValues}
                                    classes={{ root: classes.searchBarChips }}
                                    />
                                                            
                                </Grid>
                            
                            </Grid>
           
                          <Grid container className={classes.mt30}>  
                            <Grid item xs={12}>    
                            <Typography className={classes.inputLable}>Align to Master Plan at (Version Plan will become same to master at this point) </Typography>  
                            <MyPATTextField
                             fullWidthControl
                              inputId=""
                              name=""
                              value={phaseAlignment}
                              disabled={true}
                             />              
                            </Grid>
                            </Grid>

                       
                          </>
                        }
                {this.state.selectedCourseType === 'Goals' ? (
                  <div>
                    <Grid container spacing={16} justify="flex-start">
                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.basicDetails.contentPreferences.conceptTests
                                  .enabled
                              }
                              onChange={() =>
                                this.handleToggle(ContentPreferences.conceptTests)
                              }
                              // disabled={true}
                              disabled={this.state.basicDetails.contentPreferences.conceptTests.enabled &&
                                this.state.basicDetailsInitialState.contentPreferences.conceptTests.enabled}
                            />
                          }
                          label="Do you want Concept Test in this course?"
                          labelPlacement="start"

                        />
                        {/* </FormGroup> */}
                      </Grid>

                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.basicDetails.contentPreferences.video
                                  .enabled
                              }
                              onChange={() =>
                                this.handleToggle(ContentPreferences.video)
                              }
                              disabled={this.state.basicDetails.contentPreferences.video.enabled &&
                                this.state.basicDetailsInitialState.contentPreferences.video.enabled}
                            />
                          }
                          label="Do you want Videos in this course?"
                          labelPlacement="start"
                        />
                        {/* </FormGroup> */}
                      </Grid>
                    </Grid>
                    <Grid container spacing={16} justify="flex-start">
                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.basicDetails.contentPreferences
                                  .chapterTests.enabled
                              }
                              onChange={() =>
                                this.handleToggle(ContentPreferences.chapterTests)
                              }
                              disabled={this.state.basicDetails.contentPreferences.chapterTests.enabled &&
                                this.state.basicDetailsInitialState.contentPreferences.chapterTests.enabled}
                            />
                          }
                          label="Do you want Chapter Test in this course?"
                          labelPlacement="start"
                        />
                        {/* </FormGroup> */}
                      </Grid>

                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.basicDetails.contentPreferences.studyNotes
                                  .enabled
                              }
                              onChange={() =>
                                this.handleToggle(ContentPreferences.studyNotes)
                              }
                              disabled={this.state.basicDetails.contentPreferences.studyNotes.enabled &&
                                this.state.basicDetailsInitialState.contentPreferences.studyNotes.enabled}
                            />
                          }
                          label="Do you want Study Notes in this course?"
                          labelPlacement="start"
                        />
                        {/* </FormGroup> */}
                      </Grid>
                    </Grid>

                    <Grid container spacing={16} justify="flex-start">
                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.basicDetails.contentPreferences
                                  .scheduledTests.enabled
                              }
                              onChange={() =>
                                this.handleToggle(
                                  ContentPreferences.scheduledTests
                                )
                              }
                              disabled={this.state.basicDetails.contentPreferences.scheduledTests.enabled &&
                                this.state.basicDetailsInitialState.contentPreferences.scheduledTests.enabled}
                            />
                          }
                          label="Do you want Scheduled Test in this course?"
                          labelPlacement="start"
                        />
                        {/* </FormGroup> */}
                      </Grid>
                    </Grid>
                    {/* </Grid> */}
                  </div>
                ) : (
                    ''
                  )}

                <Grid container spacing={16} className={classes.mt30}>

                      <Grid item xs={6}>
                        <Grid item xs={6}>
                        <Typography
                          className={[
                            classes.inputLable,
                            classes.mb0,
                          ].join(" ")}
                        >
                          Course Duration
                        </Typography>
                      </Grid>
                        <Grid item xs={6} className={classes.mb30}>
                          <MyPATSelect
                            value={this.state.basicDetails.duration}
                            name="courseDuration"
                            onChange={(e: any) => this.handleChange(e)}
                          >
                            {this.getCourseDurationOptions()}
                          </MyPATSelect>
                        </Grid>
                      </Grid>
                      

                  <Grid item xs={6}>
                    <Grid item xs={6}>
                      <Typography className={[classes.inputLable, classes.mb0].join(' ')}>
                        Course Admin
                          </Typography>
                    </Grid>
                    <Grid item xs={12}>
                    <SearchBarWithChips
                      suggestions={this.props.userSuggestions}
                      placeholderText="Select Course Admins"
                      onSelection={this.handleCourseAdminNames}
                      loggedInUserFullName={this.state.loggedInUserFullName}
                      classes={{ root: classes.searchBarChips }}
                      notFound='No User Found'
                      values={this.state.values}
                    />
                  </Grid>
                  </Grid>
                
                </Grid>
                {
                      showMenuIcon &&
                      <>
                    <Grid container spacing={16}  className={classes.mt30}>
                        <Grid item xs={12}>    
                            <Typography className={classes.inputLable}>Description </Typography>
                              <MyPATTextField
                                  placeholder=''
                                  fullWidthControl
                                  value={basicDetails.description}
                                  // className={classes.customTextarea}
                                  name='description'
                                  onChange={this.handleDescriptionChange}
                                />            
                            </Grid>
                        </Grid>
                      </>
                    }
              </Grid>
              {this.state.isMyPatClient &&
                     <> 
                    <Grid item xs={6}>
                      <Grid item xs={6}>
                        <Typography
                        style={{marginTop: '20px'}}
                          className={[
                            classes.inputLable,
                            classes.mb0,
                          ].join(" ")}
                        >
                          Share Course(with view and copy rights)
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControlLabel
                          className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.shareViewRights
                              }
                              onChange={() =>
                                this.setShareEditKey()
                              }
                            />
                          }
                          label="Share this course with FIITJEE Clients?"
                          labelPlacement="start"
                        />
                      </Grid>
                      </Grid>
                      </>}
                       </Grid>

          </CardContent>
          {/* <DialogFooter
            htmlElements={
              <>
                <Button
                  variant="contained"
                  color="primary"
                  // className={classes.btnCreateGoal}
                  type="submit"
                  // disabled={!this.state.activateUpdateCourseBtn}
                  onClick={this.handleSubmit}
                >
                  Update Course
                </Button>
              </>
            }
          /> */}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  coursePlanState: state.createCoursePlanStates.coursePlanState,
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  // basicInfo: state.courseMangementData.courseManagementReducer.basicInfo,
  userSuggestions:
    state.courseMangementData.courseManagementReducer.userSuggestions,
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  packageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData', {}),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setCoursePlanStates: createCoursePlanStatesAction.setCoursePlanStates,
      getBasicInfo: getBasicInfo,
      getActiveGoals: getActiveGoals,
      getUserSuggestions: getUserSuggestions,
      updateCourseBasicDetails: updateCourseBasicDetails,
      setCourseBasicDetails: courseManagementActions.setCourseBasicDetails,
      setBasicInfo: courseManagementActions.setBasicInfo,
      setTreeData: contentManagementAction.setTreeData,
      setPreferenceData: contentManagementAction.setPreferenceData,
      setBasicInfoMandatoryFlag: contentManagementAction.setBasicInfoMandatoryFlag
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(ComboCourseBasicInfo)));
